import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "insufficient-credits-modal" }
const _hoisted_2 = { class: "insufficient-credits-modal__header" }
const _hoisted_3 = { class: "insufficient-credits-modal__title" }
const _hoisted_4 = { class: "insufficient-credits-modal__content" }
const _hoisted_5 = { class: "insufficient-credits-modal__text" }
const _hoisted_6 = {
  key: 0,
  class: "insufficient-credits-modal__hint"
}

import { computed } from "vue";
import { useRouter } from "vue-router";
import Modal from "@/components/ui/Modal.vue";
import Button from "@/components/ui/Button.vue";
import { Icon } from "@iconify/vue";
import { useSubscriptionModals } from "@/composables/ui/useSubscriptionModals";


export default /*@__PURE__*/_defineComponent({
  __name: 'InsufficientCreditsModal',
  setup(__props) {

const router = useRouter();
const { insufficientCreditsModal, hideInsufficientCreditsModal } = useSubscriptionModals();

const show = computed(() => insufficientCreditsModal.show);
const message = computed(() => insufficientCreditsModal.message);
const title = computed(() => insufficientCreditsModal.title || "Insufficient Credits");
const ctaLabel = computed(() => insufficientCreditsModal.ctaLabel || "Purchase Credits");
const showPurchaseHint = computed(() => insufficientCreditsModal.showPurchaseHint ?? true);
const ctaPath = computed(
  () => insufficientCreditsModal.ctaPath || "/settings/billing?openPurchase=true"
);

const handleClose = () => {
  hideInsufficientCreditsModal();
};

const handlePurchaseCredits = () => {
  hideInsufficientCreditsModal();
  router.push(ctaPath.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: show.value,
    onClose: handleClose,
    title: title.value,
    size: "md",
    "close-on-backdrop": true,
    "z-index": 10100
  }, {
    footer: _withCtx(() => [
      _createVNode(Button, {
        variant: "secondary",
        onClick: handleClose
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Maybe Later", -1)
        ]))]),
        _: 1
      }),
      _createVNode(Button, {
        class: "insufficient-credits-modal__cta-btn",
        onClick: handlePurchaseCredits
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Icon), {
            icon: "mdi:credit-card-outline",
            class: "insufficient-credits-modal__btn-icon"
          }),
          _createTextVNode(" " + _toDisplayString(ctaLabel.value), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Icon), {
            icon: "mdi:wallet-outline",
            class: "insufficient-credits-modal__icon"
          }),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(title.value), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(message.value), 1)
        ]),
        (showPurchaseHint.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                width: "14",
                height: "14"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" Minimum purchase: $20.00 ", -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})